import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { arrayByLength } from "../../../../../shared";

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const dictionaryCalendar = await dictionariesService.getDictionary({
    id: 'calendar-origin',
    parameters: {},
  });
  const calendarItems = await dictionaryCalendar.getAll();
  const currentYearId = Number(`1${(new Date()).getFullYear() - 1}0101`);
  const [countLastYears, yearStep, yearFrequency, weekFrequency, monthFrequency] = [8, 10000, 1, 7, 4];
  const yearsIds = arrayByLength(countLastYears).map((_, i) => currentYearId - (i * yearStep));
  const sordetItems = calendarItems.sort((a, b) => Number(a.id) - Number(b.id));
  const allChildren = sordetItems.reduce((result, item) => {
    const isPrimaryChild = yearsIds.includes(Number(item.id));
    const parentId = item.getValue<number | string>("parent")?.toString();
    const isSecondaryChild = result.some(parentCandidate => parentCandidate.id === parentId);
    const isChild = isPrimaryChild || isSecondaryChild;
    if (isChild) {
      result.push(item);
    }
    return result;
  }, [] as DictionaryItem[]);

  const calendarValuesItems = allChildren.filter(item => [yearFrequency, weekFrequency, monthFrequency].includes(item.getValue<number>("frequencyId")!));

  return {
    calendar: calendarValuesItems.map(item => Number(item.id)),
  };
}